// extracted by mini-css-extract-plugin
export default {"toggler":"RarumTabs_toggler__W2qGn","tabContainer":"RarumTabs_tabContainer__Qtzko","tab":"RarumTabs_tab__jvnTB","large":"RarumTabs_large__5MoXN"};